import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    max-height: 100%;
    overflow: hidden;
    overflow-y: scroll;
}
`;

export const Header = styled.div`
    height: 40px;
    border-bottom: 1px solid #f0f0f0;
    > button {
        float: right;
    }
}
`;

export const SubmitButtonArea = styled.div`
width: 100%;
margin-top: 10px;
> button {
   width:100%;
}
}
`;

export const FormArea = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    > * { 
        margin-bottom: 10px;
    }
}
`;


